import Select from '@/modules/core/components/shared/Select/Select'

export default Select
